import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { selectedHotelSelector } from '../../property/propertySlice';
import { offerLoaderSelector } from '../cmsSlice';
import './CityGuide.scss';
import { Drawer, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { validateUserSession } from '../../../utils/authUtils';
import {
  CITY_GUIDE_TYPE_CATEGORY,
  CITY_GUIDE_CATEGORY_VIEW,
  CITY_GUIDE_CATEGORY_CREATE,
  CITY_GUIDE_CATEGORY_EDIT,
  CITY_GUIDE_TYPE_ACTIVITIES,
  CITY_GUIDE_CREATE,
  CITY_GUIDE_EDIT,
  CITY_GUIDE_VIEW,
  CITY_GUIDE,
} from '../../../constants/CityGuideConst';
import CityGuideCreate from './city-guide-activities/city-guide-create/City-Guide-Create';
import CityGuideList from './city-guide-activities/city-guide-list/City-Guide-List';
import './CityGuide.scss';
import CityGuideCategoryCreate from './city-guide-categories/category-create/Category-Create';
import CityGuideCategoryView from './city-guide-categories/category-view/City-Guide-Category-View';
import CityGuideCategoryList from './city-guide-categories/category-list/City-Guide-Category-List';
import CityGuideView from './city-guide-activities/city-guide-view/City-Guide-View';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    borderRadius: '26px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  input: {
    display: 'none',
  },
}));

const CityGuide = (props) => {
  const { permissions, showLoader = () => {} } = props;
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(CITY_GUIDE_TYPE_CATEGORY);
  const selectedHotel = useSelector(selectedHotelSelector);
  const loader = useSelector(offerLoaderSelector);
  const history = useHistory();
  const [state, setState] = useState({
    type: CITY_GUIDE_CATEGORY_CREATE,
    status: false,
  });
  const [viewState, setViewState] = useState({
    type: CITY_GUIDE_CATEGORY_VIEW,
    status: false,
    obj: null,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    if (activeTab === CITY_GUIDE_TYPE_CATEGORY || activeTab === CITY_GUIDE_TYPE_ACTIVITIES) {
      setPage(0);
      setRowsPerPage(5);
    }
  }, [activeTab]);

  useEffect(() => {
    validateUserSession(history);
  }, [history]);

  useEffect(() => {
    if (selectedHotel && viewState.status) {
      setActiveTab(CITY_GUIDE_TYPE_CATEGORY);
      setViewState({
        type: '',
        status: false,
        obj: null,
      });
    }
  }, [selectedHotel]);

  const onDrawerToggle = (type, status, obj) => {
    setState({ type: type, status: status, obj: obj });
  };

  const onViewToggle = (type, status, obj) => {
    setViewState({ type: type, status: status, obj: obj });
  };

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setState(open);
  };

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case CITY_GUIDE_CREATE:
        return (
          <CityGuideCreate toggleDrawer={onDrawerToggle} hotelId={selectedHotel} loader={loader} />
        );
      case CITY_GUIDE_EDIT:
        return (
          <CityGuideCreate
            toggleDrawer={onDrawerToggle}
            cityGuide={state.obj}
            hotelId={selectedHotel}
            loader={loader}
            showLoader={showLoader}
          />
        );
      case CITY_GUIDE_CATEGORY_CREATE:
        return (
          <CityGuideCategoryCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            loader={loader}
            showLoader={showLoader}
          />
        );
      case CITY_GUIDE_CATEGORY_EDIT:
        return (
          <CityGuideCategoryCreate
            toggleDrawer={onDrawerToggle}
            cityGuide={state.obj}
            hotelId={selectedHotel}
            loader={loader}
            showLoader={showLoader}
          />
        );
      default:
        break;
    }
  };

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case CITY_GUIDE_CATEGORY_VIEW:
        return (
          <CityGuideCategoryView
            cityGuideCategory={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            permissions={permissions}
          ></CityGuideCategoryView>
        );
      case CITY_GUIDE_VIEW:
        return (
          <CityGuideView
            permissions={permissions}
            cityGuide={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
          />
        );
      default:
        break;
    }
  };

  return (
    <>
      <Drawer
        anchor={'right'}
        open={state.status}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        {switchDrawerContent(state)}
      </Drawer>
      {viewState.status ? (
        <>{switchViewContent(viewState)}</>
      ) : (
        <div className='container mt-4'>
          <div className='row d-flex'>
            <div className='col-md-6'>
              <span className='page-title'>{CITY_GUIDE}</span>
            </div>
          </div>

          <div className='row d-flex mt-4 accommodation-list'>
            <div className='d-flex flex-wrap'>
              <Button
                size='large'
                variant={activeTab === CITY_GUIDE_TYPE_CATEGORY ? 'outlined' : 'text'}
                className={
                  activeTab === CITY_GUIDE_TYPE_CATEGORY
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(CITY_GUIDE_TYPE_CATEGORY)}
              >
                Category
              </Button>
              <Button
                size='large'
                variant={activeTab === CITY_GUIDE_TYPE_ACTIVITIES ? 'outlined' : 'text'}
                className={
                  activeTab === CITY_GUIDE_TYPE_ACTIVITIES
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(CITY_GUIDE_TYPE_ACTIVITIES)}
              >
                Activities
              </Button>
            </div>
          </div>

          <div className='row mx-2 d-flex mt-4'>
            <div className='card shadow'>
              {activeTab === CITY_GUIDE_TYPE_CATEGORY && (
                <CityGuideCategoryList
                  permissions={permissions}
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  selectedHotel={selectedHotel}
                  state={state}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
              {activeTab === CITY_GUIDE_TYPE_ACTIVITIES && (
                <CityGuideList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  hotelId={selectedHotel}
                  loader={loader}
                  permissions={permissions}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CityGuide;
